export default __webpack_public_path__ + "static/media/dateIcon.43454aa5.svg";